export const getTopLeftOfImageBoundingBox = (image: fabric.Image) => {
  if (!image.aCoords) {
    return [0, 0];
  }

  const points = [image.aCoords.bl, image.aCoords.br, image.aCoords.tl, image.aCoords.tr];
  const x = points.map(x => x.x);
  const y = points.map(x => x.y);

  return [Math.min(...x), Math.min(...y)];
};
